import * as React from "react";
import {
	ActionTypes,
	Action,
	State,
	Dispatch,
	CreateCoursesProviderProps,
} from "./types";

const CreateCoursesStateContext = React.createContext<
	{ state: State; dispatch: Dispatch } | undefined
>(undefined);

function createCoursesReducer(state: State, action: Action) {
	switch (action.type) {
		case ActionTypes.HANDLE_CHANGE_FORM_STEP: {
			return {
				...state,
				currentStep: action.payload.currentStep,
			};
		}
		default: {
			// TODO: still enhancing the types here
			// eslint-disable-next-line @typescript-eslint/ban-ts-comment
			// @ts-ignore
			throw new Error(`Unhandled action type: ${action.type}`);
		}
	}
}

function CreateCoursesProvider({ children }: CreateCoursesProviderProps) {
	const [state, dispatch] = React.useReducer(createCoursesReducer, {
		currentStep: 0,
	});

	// eslint-disable-next-line react/jsx-no-constructed-context-values
	const value = { state, dispatch };
	return (
		<CreateCoursesStateContext.Provider value={value}>
			{children}
		</CreateCoursesStateContext.Provider>
	);
}

function useCreateCourses() {
	const context = React.useContext(CreateCoursesStateContext);
	if (context === undefined) {
		throw new Error(
			"useCreateCourses must be used within a CreateCoursesProvider",
		);
	}
	const { state, dispatch } = context;
	return { state, dispatch };
}

export { useCreateCourses, CreateCoursesProvider };
